/** Property-panel categories for a GALLERY topic, in tool-rail order. */
export type StudioCategory = 'template' | 'material' | 'print' | 'color' | 'frame' | 'matting'

export interface StudioCategoryDef {
  id: StudioCategory
  label: string
}

/** Order mirrors PatternAssetsMap['201'] (gallery) in src/utils/constants.ts */
export const STUDIO_CATEGORIES: StudioCategoryDef[] = [
  { id: 'template', label: 'Scene' },
  { id: 'material', label: 'Material' },
  { id: 'print', label: 'Photos' },
  { id: 'color', label: 'Color' },
  { id: 'frame', label: 'Frame' },
  { id: 'matting', label: 'Matting' },
]
